.container {
  font-family: Poppins, system-ui, sans-serif;
}

.header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 6px;
}

.headerText {
  font-size: 12px;
  color: #6b7280; /* gray-500 */
}

.bar {
  border-radius: 6px;
  overflow: hidden;
  background: #e5e7eb; /* gray-200 backdrop for empty space */
  display: flex;
}

.segment {
  height: 100%;
  cursor: pointer;
  transition: opacity 120ms ease, outline 120ms ease, filter 120ms ease;
  outline: none;
  flex: 0 0 auto; /* respect width percentages and avoid flex shrinking */
}

.segmentDimmed {
  opacity: 0.35;
}

.segmentFocused {
  outline: 2px solid rgba(0, 0, 0, 0.25);
  filter: saturate(1.2);
}

.legend {
  margin-top: 8px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 8px;
}

.legendItem {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: white;
  cursor: pointer;
  text-align: left;
}

.legendItemActive {
  background: rgba(0, 0, 0, 0.03);
}

.legendSwatch {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
  flex: 0 0 auto;
}

.legendItemActive .legendSwatch {
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.25);
}

.legendLabel {
  font-size: 13px;
  color: #111827; /* gray-900 */
}

.legendValue {
  margin-left: auto;
  font-variant-numeric: tabular-nums;
  font-size: 13px;
  color: #374151; /* gray-700 */
}
